import { render } from "./BaseSpinner.vue?vue&type=template&id=66d83558&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=66d83558&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d83558"]])

export default __exports__